import React from 'react';
import { Select, Radio, DatePicker } from 'antd';
import styles from './Filters.css';

const { RangePicker } = DatePicker;

const defaultSelectProps = {
  style: { width: 230 },
  showArrow: true,
  showSearch: true,
  allowClear: true,
  notFoundContent: null,
  defaultActiveFirstOption: true,
  optionFilterProp: 'children',
};

type Props = {
  filters: any,
  clients: [],
  onChangeFilter: (key: any, value: any) => void
}

export default class extends React.PureComponent<Props> {

  render () {

    const {
      filters,
      clients,
      onChangeFilter
    } = this.props;

    return (

        <React.Fragment>

          <div className={styles.filtersRow}>

              <Radio.Group
                  value={filters.quick_filter}
                  onChange={(event) => onChangeFilter('quick_filter', event.target.value)}
              >
                  <Radio.Button
                      style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
                      value="All"
                      key="all"
                  >
                      All
                  </Radio.Button>

                  <Radio.Button
                      style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
                      value="My Orders"
                      key="My Orders"
                  >
                      My Orders
                  </Radio.Button>


              </Radio.Group>

          </div>

          <div className={styles.filtersRow}>

        <Select
          {...Object.assign({}, defaultSelectProps)}
          placeholder="Filter by Client"
          value={filters.client_id}
          onChange={(value) => onChangeFilter('client_id', value)}
        >

          {clients.map(client => (
            <Select.Option key={client.id}>
              {`${client.name}`}
            </Select.Option>
          ))}

        </Select>

        <div style={{ width: 10 }} />

        <Radio.Group
          value={filters.extra_works}
          onChange={(event) => onChangeFilter('extra_works', event.target.value)}
        >

          <Radio.Button
            value='all'
            style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
          >
            All
          </Radio.Button>

          <Radio.Button
            value={0}
            style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
          >
            New
          </Radio.Button>

          <Radio.Button
            value={1}
            style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
          >
            Extra
          </Radio.Button>

          <Radio.Button
            value={2}
            style={{ minWidth: 100, textAlign: 'center', fontSize: 12 }}
          >
            Procurement
          </Radio.Button>

        </Radio.Group>

        <div style={{ width: 10 }} />

        <RangePicker
          value={filters.date_between}
          onChange={(value) => onChangeFilter('date_between', value)}
          format="DD/MM/YYYY"
        />
          </div>

          <div className={styles.filtersRow}>

        <Radio.Group
          value={filters.po_loaded}
          onChange={(event) => onChangeFilter('po_loaded', event.target.value)}
        >

          <Radio.Button
            value='all'
            style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
          >
            All
          </Radio.Button>

          <Radio.Button
            value='loaded'
            style={{ minWidth: 90, textAlign: 'center', fontSize: 12 }}
          >
            PO Loaded
          </Radio.Button>

          <Radio.Button
            value='not_loaded'
            style={{ minWidth: 100, textAlign: 'center', fontSize: 12 }}
          >
            PO Not Loaded
          </Radio.Button>

        </Radio.Group>

        <div style={{ width: 10 }} />

        <Radio.Group
          value={filters.sent_to_subcontractor}
          onChange={(event) => onChangeFilter('sent_to_subcontractor', event.target.value)}
        >

          <Radio.Button
            value='all'
            style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
          >
            All
          </Radio.Button>

          <Radio.Button
            value='sent'
            style={{ minWidth: 110, textAlign: 'center', fontSize: 12 }}
          >
            Sent to Subby
          </Radio.Button>

          <Radio.Button
            value='not_sent'
            style={{ minWidth: 130, textAlign: 'center', fontSize: 12 }}
          >
            Not Sent to Subby
          </Radio.Button>

        </Radio.Group>

        <div style={{ width: 10 }} />

        <Radio.Group
          value={filters.procurement_only}
          onChange={(event) => onChangeFilter('procurement_only', event.target.value)}
        >

          <Radio.Button
            value='all'
            style={{ minWidth: 70, textAlign: 'center', fontSize: 12 }}
          >
            All
          </Radio.Button>

          <Radio.Button
            value='yes'
            style={{ minWidth: 150, textAlign: 'center', fontSize: 12 }}
          >
            Procurement Only
          </Radio.Button>

        </Radio.Group>

          </div>
      </React.Fragment>

    )
  }
}
